import { Vehicle } from '../../domain/vehicle/Vehicle';
import { TableColumn, parseDefaultTableColumns } from '../shared/tableColumns';

export const vehiclesTableColumnKeys = [
  // `icon`,
  `label`,
  `phone`,
  `email`,
  `plate`,
  `brand`,
  `external_id`,
  `vehicle_model`,
  `price_per_distance`,
  `price_per_minute`,
  `comments`,
  `default_time_window`,
  `default_max_distance`,
  `default_min_distance`,
  `default_max_time`,
  `default_min_time`,
  `default_max_weight`,
  `default_max_volume`,
  `default_max_services`,
  // `default_capacity`,
  `default_start_location`,
  `default_end_location`,
  `default_provides`,
  // `custom_fields`,
  `created_at`,
] as const;

export type VehiclesTableColumnKeys = (typeof vehiclesTableColumnKeys)[number];

export type VehiclesTableColumn = TableColumn<VehiclesTableColumnKeys, Vehicle>;

export const VEHICLES_DEFAULT_TABLE_COLUMNS: Array<VehiclesTableColumn> = [
  // icon: false,
  {
    identifier: `label`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },

  {
    identifier: `phone`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `email`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `plate`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `brand`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `external_id`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `vehicle_model`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `price_per_distance`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `price_per_minute`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `comments`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_time_window`,
    type: `Array`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_max_distance`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_min_distance`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_max_time`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_min_time`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_max_weight`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_max_volume`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_max_services`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  // default_capacity: false,
  {
    identifier: `default_start_location`,
    type: `Location`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_end_location`,
    type: `Location`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_provides`,
    type: `Array`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  // custom_fields: false,
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getVehiclesTableColumns = (): Array<VehiclesTableColumn> => {
  const storedTableColumns = localStorage.getItem(`VEHICLES_TABLE_COLUMNS`);
  if (!storedTableColumns) return VEHICLES_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<VehiclesTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: VEHICLES_DEFAULT_TABLE_COLUMNS,
  });
};

export const setVehiclesTableColumns = (tableColumns: Array<VehiclesTableColumn>) => {
  localStorage.setItem(`VEHICLES_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
